import { styled } from '@mui/material/styles';

export const MainLayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#FF0000',
  // backgroundColor: theme.palette.background.default,
  height: '100%',
  paddingTop: 64,
}));
